"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { TRIAL_PATH } from "./shared";

// Mobile-only bar that slides in once the hero has scrolled out of view.
export default function StickyTrialCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hero = document.querySelector(".seo-lp .hero");
    if (!hero || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const past = !entry.isIntersecting;
        setShow(past);
        document.body.classList.toggle("seo-lp-stuck", past);
      },
      { rootMargin: "-60px 0px 0px 0px" },
    );
    observer.observe(hero);

    return () => {
      observer.disconnect();
      document.body.classList.remove("seo-lp-stuck");
    };
  }, []);

  return (
    <div className={`sticky${show ? " show" : ""}`}>
      <small>
        <strong style={{ color: "var(--ink)" }}>Free 30-day trial</strong>
        <br />
        No credit card required
      </small>
      <Link href={TRIAL_PATH} className="btn btn-primary btn-sm">
        Start Free Trial
      </Link>
    </div>
  );
}
